import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import ClientLogin from './portal/ClientLogin';
import ClientPortal from './portal/ClientPortal';
import FacebookDataDeletion from './FacebookDataDeletion';

function PrivateAdmin({ children }) {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  return token && role === 'admin' ? children : <Navigate to="/admin/login" replace />;
}

function PrivateClient({ children }) {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  return token && role === 'client' ? children : <Navigate to="/portal/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/portal/login" replace />} />
        <Route path="/portal/login" element={<ClientLogin />} />
        <Route path="/portal/*" element={<PrivateClient><ClientPortal /></PrivateClient>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<PrivateAdmin><AdminDashboard /></PrivateAdmin>} />
        <Route path="/facebook/data-deletion" element={<FacebookDataDeletion />} />
      </Routes>
    </BrowserRouter>
  );
}
